export const getCustomersDataResp = [
  {
    id: "7a1a0820-e8d5-41aa-bb99-29b0dcb76634",
    customerCode: "SG",
    name: "Signol",
    industry: "aviation",
    language: "en",
    corporateEmails: "geronimo.perez.salas+demo_sg@signol.io",
    baselinePeriod: 3,
    preferredEventName: "flight",
    preferredEventNamePlural: "flights",
    reportingDelay: 1,
    isDeleted: false,
  },
  {
    id: "7a1a0820-e8d5-41aa-bb99-29b0dcb76635",
    customerCode: "DA",
    name: "Demo Air",
    industry: "aviation",
    language: "en",
    corporateEmails: "geronimo.perez.salas+demo_vs@signol.io",
    baselinePeriod: 3,
    preferredEventName: "flight",
    preferredEventNamePlural: "flights",
    reportingDelay: 2,
    isDeleted: false,
  },
  {
    id: "7a1a0820-e8d5-41aa-bb99-29b0dcb76636",
    customerCode: "BSM",
    name: "BSM",
    industry: "shipping",
    language: "en",
    corporateEmails: "geronimo.perez.salas+demo_bsm@signol.io",
    baselinePeriod: 3,
    preferredEventName: "opportunity",
    preferredEventNamePlural: "opportunities",
    reportingDelay: 1,
    isDeleted: false,
  },
];
